export default "__VITE_ASSET__CsN35mmw__"